import { render, staticRenderFns } from "./DataContainer.vue?vue&type=template&id=4949d5b9"
import script from "./DataContainer.vue?vue&type=script&lang=js"
export * from "./DataContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports